import { render, staticRenderFns } from "./ResumationMultiSelect.vue?vue&type=template&id=080b7923&"
import script from "./ResumationMultiSelect.vue?vue&type=script&lang=js&"
export * from "./ResumationMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports